@if (configuration) {
    <section class="nw-highlight-block">
        @if (configuration.header) {
            <h2 class="nw-highlight-block__header">{{ configuration.header }}</h2>
        }

        <div class="nw-highlight-block__sections">
            @for (section of configuration.sections; track $index) {
                <div class="nw-highlight-block__sections__item">
                    @if (section.icon) {
                        <img
                            class="nw-highlight-block__sections__item__icon"
                            [ngSrc]="section.icon"
                            width="40"
                            height="40"
                            [alt]="section.header + ' icon'"
                        />
                    }

                    <h3 class="nw-highlight-block__sections__item__header">
                        {{ section.header }}
                    </h3>

                    @if (section.content) {
                        <div
                            class="nw-highlight-block__sections__item__content"
                            [innerHTML]="section.content | sanitizeHtml"
                        ></div>
                    }

                    @if (section.ctaText && section.ctaUrl) {
                        <a
                            [href]="section.ctaUrl"
                            class="nw-button nw-button--primary nw-button--m nw-outline-button nw-highlight-block__sections__item__cta"
                        >
                            {{ section.ctaText }}
                        </a>
                    }
                </div>
            }
        </div>
    </section>
}
